/**
 * Web Vibration haptics bridge.
 *
 * Pocock-style narrow union for haptic kinds; centralised pattern table.
 * iOS Safari ignores `navigator.vibrate` (Apple's choice) — we degrade silently.
 */

type Haptic = "tap" | "select" | "success" | "error" | "completion";

const PATTERNS = {
  tap: [10],
  select: [20],
  success: [50, 30, 50],
  error: [200],
  completion: [40, 60, 40, 60, 200],
} as const satisfies Record<Haptic, readonly number[]>;

const isHaptic = (k: unknown): k is Haptic =>
  typeof k === "string" && k in PATTERNS;

type Ports = {
  readonly haptic?: { readonly subscribe: (h: (k: string) => void) => void } | undefined;
};

const supportsVibrate: boolean =
  typeof navigator !== "undefined" && "vibrate" in navigator;

export const wireHapticsBridge = (ports: Ports): void => {
  if (ports.haptic === undefined) return;
  ports.haptic.subscribe((kind) => {
    if (!isHaptic(kind)) {
      console.warn(`[haptics] unknown kind: ${kind}`);
      return;
    }
    if (!supportsVibrate) return;
    navigator.vibrate([...PATTERNS[kind]]);
  });
};
